var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"watermark",style:(`background-image: url(${_vm.name}),url(${_vm.name}),url(${_vm.name});`),attrs:{"id":"watermark"}})
}
var staticRenderFns = []

export { render, staticRenderFns }